import { MessageCard, MessageCardSeverity } from 'azure-devops-ui/MessageCard';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useSettings } from '../hooks/useSettings';
import { CommonService } from '../services/common.service';
import { useProfileService } from '../hooks/useProfileService';
import { UserProfile } from '../clients/ogg';

export default function Disclaimer() {
  const settings = useSettings();
  const profileService = useProfileService();
  const [showMistakesWarning, setshowMistakesWarning] = useState(true);
  const [showInstall, setshowInstall] = useState(true);
  const [showEvaluationWarning, setShowEvaluationWarning] = useState(true);
  const [profile, setProfile] = useState<UserProfile>();

  async function getProfile() {
    const p = await profileService.getProfile();
    setProfile(p);
  }

  useEffect(() => {
    getProfile();
  }, [settings]);

  return (
    <div className='rhythm-vertical-8'>
      {showEvaluationWarning && !settings.isWebApp && profile?.isFreeDefaultPlan && (
        <MessageCard
          className='flex-self-stretch'
          severity={MessageCardSeverity.Warning}
          onDismiss={() => setShowEvaluationWarning(false)}
          buttonProps={[
            {
              text: 'Settings',
              onClick: () => CommonService.goToProjectSettings(),
              iconProps: { iconName: 'Settings' },
            },
          ]}
        >
          <b>You're on the Free Plan! 🚀</b>&nbsp;Enjoy access to {profile.requestLimit} requests. Go to&nbsp;
          <i>Settings &gt; Profile</i>&nbsp;to upgrade and get more requests.
        </MessageCard>
      )}
      {showMistakesWarning && (
        <MessageCard
          className='flex-self-stretch'
          severity={MessageCardSeverity.Info}
          onDismiss={() => setshowMistakesWarning(false)}
        >
          Ogg can make mistakes. Consider checking important information 🔍.
        </MessageCard>
      )}
      {isMobile && showInstall && settings.isWebApp && (
        <div style={{ paddingTop: '20px' }}>
          <MessageCard
            className='flex-self-stretch'
            severity={MessageCardSeverity.Info}
            onDismiss={() => setshowInstall(false)}
            buttonProps={[
              {
                text: 'Install',
                onClick: () => {
                  window.open(
                    'https://marketplace.visualstudio.com/items?itemName=Intriq.ogg-4-ado',
                    '_blank'
                  );
                },
              },
            ]}
          >
            Ready to try the Azure DevOps Ogg extension? Install it from the Marketplace.
          </MessageCard>
        </div>
      )}
    </div>
  );
}
